const COUNTRY_REQUEST = 'GEO_COUNTRY_REQUEST'
const COUNTRY_SUCCESS = 'GEO_COUNTRY_SUCCESS'
const COUNTRY_FAILURE = 'GEO_COUNTRY_FAILURE'
const SET_COUNTRY = 'GEO_SET_COUNTRY'
const IP_REQUEST = 'GEO_IP_REQUEST'
const IP_SUCCESS = 'GEO_IP_SUCCESS'
const IP_FAILURE = 'GEO_IP_FAILURE'
const LAT_LONG_REQUEST = 'GEO_LAT_LONG_REQUEST'
const LAT_LONG_SUCCESS = 'GEO_LAT_LONG_SUCCESS'
const LAT_LONG_FAILURE = 'GEO_LAT_LONG_FAILURE'

export default {
  COUNTRY_REQUEST,
  COUNTRY_SUCCESS,
  COUNTRY_FAILURE,
  SET_COUNTRY,
  IP_REQUEST,
  IP_SUCCESS,
  IP_FAILURE,
  LAT_LONG_REQUEST,
  LAT_LONG_SUCCESS,
  LAT_LONG_FAILURE,
}
